import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SingleSideTabWithLink from "../../components/singleTabWithLink/singleTabWithLink";

const ExternalWorklists = () => {
  const location = useLocation();
  const [showSideNav, setShowSideNav] = useState(false);

  const sideNavElements = [{ id: "all-pa-orders", label: "All Orders" }];

  useEffect(() => {
    const shouldShowSideNav = sideNavElements.some((element) =>
      location.pathname.startsWith(`/external-worklist/${element.id}`),
    );
    setShowSideNav(shouldShowSideNav);
  }, [location]);

  return (
    <div className="worklists--layout p-2">
      {showSideNav && (
        <div className="worklists--navigation">
          {sideNavElements.map((sideNavElement) => (
            <SingleSideTabWithLink
              key={sideNavElement.id}
              id={sideNavElement.id}
              label={sideNavElement.label}
            />
          ))}
        </div>
      )}
      <div
        className={`worklists--outlet ${showSideNav ? "" : "worklists--outlet__only"}`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default ExternalWorklists;
